<template>
    <div class="mien-manager">
         <Card :padding="10" shadow title="查询条件" class="bt-card">
            <div class="search-con search-con-top">
                <Input v-model.trim="key" clearable @on-enter="searchMienList" @on-clear="searchMienList" placeholder="名称" class="search-input"/>
                <Button type="primary" icon="md-search" @click="searchMienList">搜索</Button>
            </div>
        </Card>
        
        <Card :padding="10" title="栖智风采列表" shadow>
            <p slot="extra">
               <Button @click="handleAddMien" type="primary">新增</Button>
            </p>
            <Table :columns="columns" border :data="list" stripe></Table>
            <Page :total="total" :current="page" :page-size="size" @on-change="handlePageChange" @on-page-size-change='handlePageSize' show-total show-elevator show-sizer class-name="bt-page"/>
        </Card>

        <Modal
            v-model="modal"
            :title="editMien.id == 0 ? '新增栖智风采' : '编辑栖智风采'"
            @on-visible-change="resetForm"
            :width="600">
            <Form ref="editMien" :model="editMien" :label-width="100">
                <FormItem label="标题" prop="title" :rules="{required: true, message: '标题不能为空'}">
                   <Input v-model.trim="editMien.title" placeholder="请输入标题"></Input>
                </FormItem>
                <FormItem label="图片" prop="pic" :rules="{required: true, message: '图片不能为空'}">
                    <CustomUpload v-model="editMien.pic"></CustomUpload>
                </FormItem>
                <FormItem label="内容" prop="content" :rules="{required: true, message: '内容不能为空'}">
                    <editor v-model="editMien.content"></editor>
                </FormItem>
                <FormItem label="排序码" prop="orders" :rules="{required: true, min: 0,type: 'number',message: '排序码不能为空', trigger: 'change'}">
                   <InputNumber v-model="editMien.orders" placeholder="请输入排序码"></InputNumber>
                </FormItem>
                <FormItem label="发布时间" prop="publishTime">
                   <DatePicker v-model="editMien.publishTimeDate" type="date" placeholder="请选择发布时间" style="width:100%"></DatePicker>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button type="text" size="large" @click="modal=false">取消</Button>
                <Button type="primary" size="large" @click="handleMienSubmit">确定</Button>
            </div>
        </Modal>

        <Modal
            v-model="auditBackModal"
            title="审核打回">
            <Form ref="auditBackValue" :model="auditBackValue" :label-width="100">
                <FormItem label="原因" prop="reason" :rules="{required: true, message: '原因不能为空'}">
                   <Input v-model.trim="auditBackValue.reason" maxlength="500" show-word-limit type="textarea" placeholder="请输入原因"></Input>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button type="text" size="large" @click="auditBackModal=false">取消</Button>
                <Button type="primary" size="large" @click="handleAuditBackSubmit">确定</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
import {renderShowImage,formatDate} from '@/utils';
import editor from '@/components/common/Editor';

export default {
    name: 'mienManager',
    data(){
        return {
            key: '',
            list: [],
            page: 1,
            size: 20,
            total: 1,
            columns:[{
              key: 'id',
              title: 'ID',
              align: 'center'
           },{
              key: 'title',
              title: '标题',
              tooltip: true
           },{
              key: 'pic',
              title: '图片',
              align: 'center',
              render: renderShowImage
           },{
              key: 'orders',
              title: '排序码',
              align: 'center'
           },{
              key: 'status',
              title: '审核状态',
              align: 'center',
              render: (h,{row,index})=>{
                if(row.status == 0){
                    return h('Tag',{props: {color: 'default'}},'待审核');
                }else if(row.status == 1){
                    return h('Tag',{props: {color: 'primary'}},'审核通过');
                }else {
                    return h('Tag',{props: {color: 'error'},
                        nativeOn: {
                            click: () => {
                                this.lookAuditBackReason(index);
                            }
                        }
                    },'审核失败');
                }
             }
           },{
              key: 'createTime',
              title: '创建时间',
              align: 'center',
              render: (h,{row})=>{
                  return h('span',formatDate(row.createTime,'yyyy-MM-dd hh:mm:ss'));
              }
           },{
              key: 'modifyTime',
              title: '修改时间',
              align: 'center',
              render: (h,{row})=>{
                  return h('span',formatDate(row.modifyTime,'yyyy-MM-dd hh:mm:ss'));
              }
           },{
              key: 'publishTime',
              title: '发布时间',
              align: 'center',
              render: (h,{row})=>{
                  return h('span',row.publishTime ? formatDate(row.publishTime,'yyyy-MM-dd') : '-');
              }
           },{
              key: 'option',
              title: '操作',
              minWidth: 120,
              render: (h, {row,index}) => {
                 let data = [];
                 if(row.status != 1){
                     data.push(h('Button',{
                        props: {type: 'info',size: 'small'},
                        style: {marginRight: '5px'},
                        on: {
                            click: () => {
                                this.handleEditMienStatus(index,1);
                            }
                        },
                        directives:[{
                            name: 'permission',
                            value: 'mien:audit'
                        }]
                    }, "审核通过"));
                 }
                 if(row.status != 2){
                    data.push(h('Button',{
                        props: {type: 'error',size: 'small'},
                        style: {marginRight: '5px'},
                        on: {
                            click: () => {
                                this.handleEditMienStatus(index,2);
                            }
                        },
                        directives:[{
                            name: 'permission',
                            value: 'mien:audit'
                        }]
                    }, "审核打回"));
                 }
                 data.push(h('Button',{
                        props: {type: 'success',size: 'small'},
                        style: {marginRight: '5px'},
                        on: {
                            click: () => {
                                this.handleEditMien(index);
                            }
                        }
                    }, "编辑"));
                 data.push(h('Button',{
                        props: {type: 'error',size: 'small'},
                        style: {marginRight: '5px'},
                        on: {
                            click: () => {
                                this.handleDeleteMien(index);
                            }
                        }
                    }, "删除"));
                 return h('div', data);
              }
            }],
            modal: false,
            editMien: {
               id: 0,
               title: '',
               pic: '',
               thumbnail: '',
               content: '',
               orders: 0,
               status: 0,
               publishTime: 0,
               publishTimeDate: null
            },
            auditBackModal: false,
            auditBackValue: {
                index: 0,
                status: 0,
                reason: ''
            }
        }
    },
    created(){
        this.searchMienList();
    },
    methods: {
        searchMienList(){
            this.page = 1;
            this.queryMienList();
        },
        queryMienList(){
            this.$http.post('/api/admin/getMienList',{
                key: this.key,
                pn: this.page,
                ps: this.size
            }).then(data=>{
                this.list = data.list;
                this.size = data.pageSize;
                this.total = data.total;
            });
        },
        handleAddMien(){
            this.editMien.id = 0;
            this.modal = true;
        },
        handleEditMien(index){
            this.editMien = Object.assign({},this.list[index]);
            this.editMien.publishTimeDate = this.editMien.publishTime ? new Date(this.editMien.publishTime) : null;
            this.modal = true;
        },
        handleMienSubmit(){
            this.$refs['editMien'].validate((valid) => {
              if(valid) {
                 let mien = Object.assign({},this.editMien);
                 if(mien.publishTimeDate){
                     mien.publishTime = new Date(mien.publishTimeDate).getTime();
                 }
                 delete mien.publishTimeDate;
                 this.$http.post('/api/admin/saveMien',mien).then(()=>{
                    this.$Message.success("操作成功");
                    this.queryMienList();
                    this.modal = false;
                 });
              }
           });
        },
        openAuditBack(id,status){
           this.auditBackValue = {
               id: id,
               status: status,
               reason: ''
           };
           this.auditBackModal = true;
           this.$refs['auditBackValue'].resetFields();
        },
        handleAuditBackSubmit(){
            this.$refs['auditBackValue'].validate((valid) => {
                if(valid) {
                    this.$http.post('api/admin/updateMienStatus',this.auditBackValue).then(()=>{
                        this.$Message.success("审核打回成功");
                        this.auditBackModal = false;
                        this.queryMienList();
                    });
                }
           });
        },
        handleEditMienStatus(index,status){
            let mien = this.list[index];
            if(status == 1){
                this.$Modal.confirm({
                    title: '审核操作',
                    content: '确认审核通过吗？',
                    onOk: () => {
                        this.$http.post('api/admin/updateMienStatus',{id: mien.id,status: 1}).then(()=>{
                            this.$Message.success("审核通过成功");
                            this.queryMienList();
                        });
                    }
                });
            }else if(status == 2){
                this.openAuditBack(mien.id,status);
            }else {
                this.$Message.error("无效状态");
            }
        },
        handleDeleteMien(index){
            this.$Modal.confirm({
              title: '删除操作',
              content: '确认删除该栖智风采吗？',
              onOk: () => {
                 let mien = this.list[index];
                 this.$http.post('api/admin/deleteMien',{id: mien.id}).then(()=>{
                    this.$Message.success("删除成功");
                    this.queryMienList();
                 });
              }
           });
        },
        lookAuditBackReason(index){
            this.$http.post('api/admin/queryAuditLogReason',{itemId: this.list[index].id,itemType: 8},false).then((data)=>{
                this.$Modal.error({
                    title: '打回原因',
                    content: data
                });
            });
        },
        resetForm(show){
           if(!show) {
              this.$refs.editMien.resetFields();
              this.editMien.id = 0;
           }
        },
        handlePageChange(page){
           this.page = page;
           this.queryMienList();
        },
        handlePageSize(size){
           this.size = size;
           this.page = 1;
           this.queryMienList();
        }
    },
    components: {editor}
}
</script>